/*eslint-disable func-style */
/*eslint-disable no-useless-escape */
/**
 * @method capitalizeFirstLetter
 * @param {String} string
 * @return {String}
 */
export function capitalizeFirstLetter(string) {
  if (string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
  }
  return '';
}

/**
 * containsExactMatch
 */
export function containsExactMatch(niddle, haystack) {
  const escapeRegExpMatch = function (s) {
    return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
  };
  return new RegExp(`\\b${escapeRegExpMatch(haystack)}\\b`).test(niddle);
}

export function insertSpaces(string) {
  string = string.replace(/([a-z])([A-Z])/g, '$1 $2');
  string = string.replace(/([A-Z])([A-Z][a-z])/g, '$1 $2');
  return string;
}
